import * as React from "react";
import { Row, Col, Button, notification, Icon } from "antd";
import { NavLink, RouteProps, Redirect, RouteComponentProps } from "react-router-dom";
import Form, { FormComponentProps } from "antd/lib/form";
import { BillOfLadingPaymentResponse, IBillOfLadingPaymentResponse, IBolData, IBolCharge, IVerifyFirstAtlanticPaymentResponse } from "Core/Api/Payment/Api";
import ConfirmationDetail from "./ConfirmationDetail";
import OrderDetail from "./OrderDetail";
import PaymentInformation from "./PaymentInformation";
import AuthContext from "Context/AuthContext";
import { CheckoutCompleteLayout, CheckoutComplete, ButtonLayout } from "./CheckoutConfirmation.Styled";
import { withRouter } from "react-router";
import Utility from "Core/Utility";
import check from '../../../assets/images/PaymentCheck.png'
import NotificationUtility from "Core/NotificationUtility";


export interface Props extends FormComponentProps, RouteComponentProps {
    children?: React.ReactNode
}

export interface State {
}

class CheckoutConfirmationWithoutRouterAndForm extends React.Component<Props, State> {
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;
    constructor(props: Props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        let state: IVerifyFirstAtlanticPaymentResponse = {};

        const paymentResponse = (this.props.location?.state) as IVerifyFirstAtlanticPaymentResponse;
        if (paymentResponse !== undefined) {
            if (paymentResponse.errorCode === 'EMAIL_CONFIRMATION_ERROR' || paymentResponse.errorCode === 'RECEIPT_GENERATION_ERROR') {

                NotificationUtility.warning('Issue Emailing Receipt.', `Payment successful but there was an issue emailing your receipt. Please contact Client Services at ${Utility.ContactTel()} or ${Utility.ContactEmail()} for assistance.`, 0, true)
            }
        }

    }

    render() {
        const paymentResponse = (this.props.location?.state) as IVerifyFirstAtlanticPaymentResponse;
        return (
            <>
                <Row style={{ border: "solid lightgrey 2px", borderRadius: "15px", padding: "15px 20px", marginTop: "5px" }}>
                    <Row style={{ marginBottom: '20px' }}>
                        <h2>Thank You!</h2>
                        <p>Your payment has been received</p>
                        <img src={check} />
                        <p>Below are the details of your payment.</p>
                    </Row>
                    <Row>
                        <CheckoutComplete {...CheckoutCompleteLayout}>
                            <Row>
                                <Col>
                                    {/* Receipt Details */}
                                    <ConfirmationDetail
                                        paymentResponse={paymentResponse}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {/* Order Details */}
                                    <OrderDetail
                                        receiptDetails={paymentResponse?.receipt?.data}
                                    />
                                </Col>
                            </Row>
                            <Row style={{ borderTop: 'solid 2px lightgrey', marginTop: '20px' }}>
                                <Col>
                                    {/* Payment Details */}
                                    <PaymentInformation
                                        receiptDetails={paymentResponse}
                                    />
                                </Col>
                            </Row>
                            <Row >
                                <Col {...ButtonLayout}>
                                    <Button><NavLink to="/home">Back to Home</NavLink></Button>
                                </Col>
                            </Row>
                        </CheckoutComplete>
                    </Row>
                </Row>
            </>
        )
    }
}

const CheckoutConfirmationWithoutRouter = Form.create<Props>({
    name: 'CheckoutConfirmation',
})(CheckoutConfirmationWithoutRouterAndForm);

const CheckoutConfirmation = withRouter(CheckoutConfirmationWithoutRouter);

export default CheckoutConfirmation;
